<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path fill-rule="evenodd" d="M9 2.7A6.307 6.307 0 0 0 2.7 9c0 3.474 2.826 6.3 6.3 6.3 3.474 0 6.3-2.826 6.3-6.3 0-3.474-2.826-6.3-6.3-6.3Zm1.818 9.45-2.034-2.034c-.756.234-1.611.072-2.205-.531a2.18 2.18 0 0 1-.387-2.556l1.467 1.467.927-.927-1.467-1.467a2.18 2.18 0 0 1 2.988 2.853l1.953 1.953-1.242 1.242Z" clip-rule="evenodd"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
